import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/backend";
import { CONVERSATION_QUERY_KEY } from "./conversation.query.key";

export function useCreateEmployeeDirectConversation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const res = await api.conversationCrud.createEmployeeDirectConversation();
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CONVERSATION_QUERY_KEY] });
    },
  });
}
